/*
 * the DocumentsService class handles document requests
 * http://stackoverflow.com/questions/34755350/using-http-rest-apis-with-angular-2/34758630#34758630 (see accepted answer by Pardeep Jain)
 * http://stackoverflow.com/questions/37290672/passing-parameters-in-http-get-using-angular-2 (see accepted answer by Pardeep Jain)
 * https://angular.io/docs/ts/latest/guide/server-communication.html#!#error-handling
 * by ole fjarestad
 */

import { Injectable } from '@angular/core';
import { Http, Headers, Request, RequestOptions, RequestMethod, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { api } from './api';


@Injectable()
export class DocumentsService {

	// private docCategoriesUrl = baseUrl + 'dokumenter/ajax/'; // baseUrl is defined in backend/views/layouts/main.php
	// private docCategoriesUrl: string = url.global.base + url.documents.api;
	// private docCategoriesUrl: string = 'dokumenter/ajax';
	private docCategoriesUrl: string = api.base + 'dokumenter/ajax';

	constructor(private http: Http) { }

	// private getHeaders( requestOptions: object ) {
	private getRequestOptions( options ) {
		let headers = new Headers();
		headers.append( 'Accept', 'application/json' );
		options.headers = headers;
		let requestOptions = new RequestOptions(options);
		return requestOptions;
	}

	private handleError(error: Response | any) {
		// console.error( 'No document(s) found. An error occured', error );
		return Observable.throw(error);
	}

	getDocCategories(): Observable<[{}]> {

		var requestOptions = {
			withCredentials: true,
			method: RequestMethod.Get,
			url: this.docCategoriesUrl,
		}

		let docCategories$ = this.http
						.request( new Request(this.getRequestOptions(requestOptions)) )
						// .do( (res: Response) => console.log( res ) )
						.map( (res: Response) => res.json() )
						// .do( (res: Response) => console.log( res ) )
						.catch( this.handleError );

		return docCategories$;
	}

	getDoc(id: number): Observable<{}> {

		var requestOptions = {
			withCredentials: true,
			method: RequestMethod.Get,
			url: this.docCategoriesUrl + '/' + id,
		}

		let doc$ = this.http
						.request( new Request(this.getRequestOptions(requestOptions)) )
						// .do( (res: Response) => console.log( res ) )
						.map( (res: Response) => res.json() )
						// .do( (res: Response) => console.log( res ) )
						.catch( this.handleError );

		return doc$;
	}

}



// WEBPACK FOOTER //
// ./src/app/documents.service.ts